import axios from "../../Axios/axiosConfig";
import {buildSystemCycleStateString} from "../../General/SharedMethods";

export class MonitoringService {
    baseUrl;

    constructor(serverUrl) {
        this.baseUrl = serverUrl;
    }

    getInactiveLeaks(startTime, endTime, organizationId, siteIdString) {
        let response;
        if (siteIdString) {
            response = axios.get(`${this.baseUrl}/leaks?search=startTime>=${startTime};startTime<=${endTime};closed==true;organizationId==${organizationId};(valveType=out=(66, 67, 68, 69, 70),valveType=na='');passedLimits==true;siteId=in=(${siteIdString})`);
        } else {
            response = axios.get(`${this.baseUrl}/leaks?search=startTime>=${startTime};startTime<=${endTime};closed==true;organizationId==${organizationId};(valveType=out=(66, 67, 68, 69, 70),valveType=na='');passedLimits==true`);
        }
        return response;
    }

    getActiveLeaks(selectedSystemStates) {
        const systemStateFilterParam = selectedSystemStates.length > 0 ? `;lifecyclePhase=in=(${(buildSystemCycleStateString(selectedSystemStates))})` : '';
        return axios.get(`${this.baseUrl}/leaks?search=closed==false${systemStateFilterParam}`);
    }

    getLastActiveLeaks(queryTime, selectedSystemStates) {
        const systemStateFilterParam = selectedSystemStates.length > 0 ? `;lifecyclePhase=in=(${(buildSystemCycleStateString(selectedSystemStates))})` : '';
        return axios.get(`${this.baseUrl}/leaks?search=updated>=${queryTime}${systemStateFilterParam}`);
    }

    getSitesByOrganization(organizationId) {
        return axios.get(`${this.baseUrl}/labels?search=type==site;parentId==${organizationId}`);
    }


    getOrganizations(inputValue) {
        return axios.get(`${this.baseUrl}/labels?search=type==organization;label=ik="${inputValue}"`);
    }

    async updateEditableFields(leakId, assignee, remarks, confirmation, reason, excluded, communication) {
        await axios.patch(`${this.baseUrl}/leaks/${leakId}`, {
            assignee: assignee, remarks: remarks, confirmation: confirmation, reason: reason, excluded: excluded, communication: communication
        });
    }

    getLeakHistorySummaryData(startTime, endTime, organizationId) {
        return axios.get(`${this.baseUrl}/aggregation_data/leak_history_summary?searchLeakInactiveSummary=startTime>=${startTime};startTime<=${endTime};closed==true;organizationId==${organizationId};(valveType=out=(66, 67, 68, 69, 70),valveType=na='');passedLimits==true;(excluded==false,excluded=na='')&searchLeakTotalSummary=startTime>=${startTime};startTime<=${endTime};organizationId==${organizationId};(valveType=out=(66, 67, 68, 69, 70),valveType=na='');passedLimits==true;(excluded==false,excluded=na='')&searchWaterConsumptionSummary=date>=${startTime};date<=${endTime};organizationId==${organizationId};(valveType=out=(66, 67, 68, 69, 70),valveType=na='')`);
    }

    updateOrganizationLevelFilterRules(organizationId, duration, flowrate, volume) {
        return axios.post(`${this.baseUrl}/organization_rules/${organizationId}`,
            {
                duration: duration,
                flowrate: flowrate,
                volume: volume
            }
        );
    }

    getOrganizationLevelFilterRules(organizationId) {
        return axios.get(`${this.baseUrl}/organization_rules/${organizationId}`);
    }

    updateExcludedLeaks(arr) {
        return axios.post(`${this.baseUrl}/leaks/exclude`, arr);
    }

    updateIncludedLeaks(arr) {
        return axios.post(`${this.baseUrl}/leaks/include`, arr);
    }

    getCountries(date) {
        return date ?
            axios.get(`${this.baseUrl}/leaks/countries?search=closed==false;country=nn='';startTime>=${date}`) : axios.get(`${this.baseUrl}/leaks/countries?search=closed==false;country=nn=''`);
    }
}

